import type { WatchTowerMockState } from './types';

/**
 * Pins an ATT-144 `ai-chats.id` on a Watch Tower binding row.
 *
 * The mock store keeps the Watch Tower subject. Nest keeps the transcript. Reopen uses this id.
 * Do not fall back to the newest chat on the list.
 */
export function bindIssueChatAiChatId(
  state: WatchTowerMockState,
  chatId: number,
  aiChatId: number,
): WatchTowerMockState {
  return {
    ...state,
    issueChats: state.issueChats.map((chat) => (
      chat.id === chatId ? { ...chat, aiChatId } : chat
    )),
  };
}

export function bindCreateChatAiChatId(
  state: WatchTowerMockState,
  chatId: number,
  aiChatId: number,
): WatchTowerMockState {
  return {
    ...state,
    createChats: state.createChats.map((chat) => (
      chat.id === chatId ? { ...chat, aiChatId } : chat
    )),
  };
}
